import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M25.0002 22.131L44.4646 2.66666L48.0001 6.20219L28.5358 25.6665L48.0005 45.1313L44.4649 48.6668L25.0002 29.2021L5.53553 48.6668L2 45.1313L21.4647 25.6665L2.00035 6.20219L5.53589 2.66666L25.0002 22.131Z",
		fill: "#002938"
	})
});
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
